import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface TableSearchInputProps {
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    type?: 'text' | 'number';
    disabled?: boolean;
    className?: string;
}

export function TableSearchInput({
    placeholder,
    value,
    onChange,
    type = 'text',
    disabled,
    className
}: TableSearchInputProps) {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onChange(localValue);
        }
    };

    return (
        <div className="relative flex flex-col pb-1">
            {/* `truncate` (utility Tailwind standard, nu un token din main.css) taie
                placeholder-ul curat, cu elipsa, in loc de o cadere brusca la marginea
                coloanei; `title` da textul intreg la hover, pe desktop. Latimea insasi
                vine din `ecotic-table-filter-input` (width:100%, in main.css) — corecta,
                fiindca se aliniaza la latimea coloanei; problema era doar cum se taie
                textul, nu latimea impusa. */}
            <Input
                type={type}
                placeholder={placeholder}
                aria-label={placeholder}
                title={placeholder}
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                autoComplete="off"
                className={cn("ecotic-table-filter-input truncate", className)}
            />
        </div>
    );
}
